// extracted by mini-css-extract-plugin
module.exports = {"container":"Vl-z","productName":"Wl-z","modal":"Xl-z","dimensions":"Yl-z","recipientEmail":"Zl-z","lowStock":"_l-z","recommendedFit":"am-z","notRecommendedFit":"bm-z"};